export default "__VITE_ASSET__BMOS5saB__"